import { Icons } from '@commenda/kakashi';

import { TServiceAuditPreviousOutcomeListKey } from '../helpers/ServiceAuditPreviousRoundHelper';

interface IServiceAuditPreviousOutcomeIconProps {
  listKey: TServiceAuditPreviousOutcomeListKey;
}

export const ServiceAuditPreviousOutcomeIcon = ({
  listKey,
}: IServiceAuditPreviousOutcomeIconProps) => {
  if (listKey === 'fixed') {
    return <Icons.Check className="size-4 shrink-0 text-text-success" />;
  }
  if (listKey === 'unsettled') {
    return (
      <Icons.AlertTriangle className="size-4 shrink-0 text-text-warning" />
    );
  }
  return <Icons.InfoCircle className="size-4 shrink-0 text-text-tertiary" />;
};
